export const BOOKS_BOOK_DETAIL_SET_DATA = 'BOOKS_BOOK_DETAIL_SET_DATA';
export const BOOKS_BOOK_DETAIL_RESET_DATA = 'BOOKS_BOOK_DETAIL_RESET_DATA';

export const BOOKS_BOOK_FRAGMENT_SET_DATA = 'BOOKS_BOOK_FRAGMENT_SET_DATA';
export const BOOKS_BOOK_FRAGMENT_RESET_DATA = 'BOOKS_BOOK_FRAGMENT_RESET_DATA';

export const BOOKS_BOOK_REVIEWS_SET_DATA = 'BOOKS_BOOK_REVIEWS_SET_DATA';
export const BOOKS_BOOK_REVIEWS_RESET_DATA = 'BOOKS_BOOK_REVIEWS_RESET_DATA';

export const BOOKS_BOOK_REVIEW_SET_DATA = 'BOOKS_BOOK_REVIEW_SET_DATA';
export const BOOKS_BOOK_REVIEW_RESET_DATA = 'BOOKS_BOOK_REVIEW_RESET_DATA';

export const BOOKS_BOOK_CITATIONS_SET_DATA = 'BOOKS_BOOK_CITATIONS_SET_DATA';
export const BOOKS_BOOK_CITATIONS_RESET_DATA = 'BOOKS_BOOK_CITATIONS_RESET_DATA';

export const BOOKS_BOOK_CITATION_SET_DATA = 'BOOKS_BOOK_CITATION_SET_DATA';
export const BOOKS_BOOK_CITATION_RESET_DATA = 'BOOKS_BOOK_CITATION_RESET_DATA';

export const BOOKS_BOOK_AUTHORS_SET_DATA = 'BOOKS_BOOK_AUTHORS_SET_DATA';
export const BOOKS_BOOK_AUTHORS_RESET_DATA = 'BOOKS_BOOK_AUTHORS_RESET_DATA';

export const BOOKS_SIMILAR_BOOKS_SET_DATA = 'BOOKS_SIMILAR_BOOKS_SET_DATA';
export const BOOKS_SIMILAR_BOOKS_RESET_DATA = 'BOOKS_SIMILAR_BOOKS_RESET_DATA';

export const BOOKS_COUNTERS_SET_DATA = 'BOOKS_COUNTERS_SET_DATA';

export const BOOK_PER_SUBSCRIPTION_COUNT = {
  free: 26000,
  only_pro: 16000,
  standard: 87000,
  standard_free: 115000,
  audio: 15000,
  total: 130000,
};

export const BOOK_STATUSES = {
  wantToRead: 1,
  inProgres: 2,
  finished: 3,
};

export const BOOK_STATUSES_TITLE = {
  text: [null, 'Хочу прочитать', 'Читаю', 'Прочитано'],
  audio: [null, 'Хочу послушать', 'Слушаю', 'Прослушано'],
};

export const BOOK_RENT_ERROR_MESSAGES = {
  EMAIL_IS_REQUIRED: 'Введите электронную почту',
};
